$(document).ready(function(){
	
	// -- Open infosbox --
  $('[data-city]').on('touchstart mouseover', function(){
  	var city = $(this).attr('data-city');
  	if (city != "luxembourg"){
			var cityEl = $('.city--'+city);
			var offset = setOffsetPosition($(this), cityEl);
			$('.city').removeClass('active');
			cityEl.offset(offset).addClass('active');
  	}
  });

  // -- Close infosbox --
  $('[data-city]').on('mouseleave', function(){
		$('.city').removeClass('active');
  });

	function setOffsetPosition($this, $el) {
	  var rect = $this[0].getBoundingClientRect();
	  var win = $this[0].ownerDocument.defaultView;
	  var elW = $el.width();
	  var elH = $el.height();
	  var marginB = 20;
	  return {
			top: rect.top + win.pageYOffset - (elH + marginB),
			left: rect.left + win.pageXOffset - (elW/2) + (rect.width/2)
	  };
	}

 	// -- Open first infosbox --
	$(window).on('load scroll resize orientationchange', function(){
		if ($('.blockMap').hasClass('onscreen')) {
			setTimeout(function(){
			 	var firstCity = $('[data-city="london"]');
			 	var firstTooltip = $('.city--london');
				var offset = setOffsetPosition(firstCity, firstTooltip);
			 	firstTooltip.offset(offset).addClass('active');
			 	// setTimeout(function(){
			 	// 	firstTooltip.addClass('bounce');
			 	// },300);
			},1800);
		}
	});

});